import { Col, Row } from "reactstrap";

import MonthlyProfits from "./MonthlyProfits";
import OrderOverview from "./OrderOverview";
import OrderThisMonth from "./OrderThisMonth";
import WidgetsGrid from "./WidgetsGrid";
import WidgetsWraper from "./WidgetsWraper";

const LeftGrid = () => {
  return (
    <Col xxl="12" md="12" className="box-col-8 grid-ed-12">
      <Row className="row">
        <WidgetsGrid />
        <Col xxl="7" md="7" sm="5" className="box-col-6">
          <OrderThisMonth />
        </Col>

        <Col xxl="3" md="6">
          <MonthlyProfits />
        </Col>
        <Col xxl="9" md="7">
          <OrderOverview />
        </Col>

        <Col md="12">
          <WidgetsWraper />
        </Col>
      </Row>
    </Col>
  );
};

export default LeftGrid;
